import { useMemo, useState, useCallback } from 'react';
import { ChangeAlertCallbackType, ChangeWidgetsCallbackType } from '../../../Root';
import { IconButton, Tooltip } from '@mui/material';
import { useCRMFunction } from './useCRMFunction';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import moment from 'moment';
moment.locale('es');

export const useCRMDescription = (changeAlert: ChangeAlertCallbackType, changeWidgets: ChangeWidgetsCallbackType, config, lead, platformData, platformInfo, getLeadByUuid) => {
    const { handlePartner, onHandleChangeAgent, onHandleChangeStatus, onHandleUpdateCompanyContact, onHandleCommissionUpdate } = useCRMFunction(changeAlert)

    const [data, setData] = useState([]);
    const [platform, setPlatform] = useState('');
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [activeSection, setActiveSection] = useState('');
    const [agentList, setAgentList] = useState(null);
    const [check, setCheck] = useState(false);
    const [info, setInfo] = useState([]);
    const agent = localStorage.session ? JSON.parse(localStorage.session) : {};

    
    const saveData = async (result) => {
        let validate = Array.isArray(result?.content);
        setData(JSON.parse(JSON.stringify(validate ? result.content || [] : [result.content])));
        setTotalRows(result?.pagination?.total_documents || 0);
        setLoading(false)
    };
    
    const getPartner = async (section, lead, newPage = page, newPerPage = perPage, crmType = platform) => {
        setLoading(true);
        setActiveSection(section);
        setPlatform(crmType);

        let resp = await handlePartner(section, lead, newPage, newPerPage);
        if(resp){
            if(resp['content'].length > 1 && lead["ppal_contact"]){
                resp['content'].unshift(resp['content'].splice(resp['content'].findIndex(e => e.uuid === lead["ppal_contact"]["uuid"]), 1)[0])
            }
            saveData(resp);
        }
        setPage(newPage);
        setLoading(false);
    };
        
    const handlePageChange = (newPage) => {
        setPage(newPage);
        getPartner(activeSection, lead, newPage, perPage);
    };
    const handlePerRowsChange = async (newPerPage, newPage) => {
        setPage(newPage);
        setPerPage(newPerPage);
        getPartner(activeSection, lead, newPage, newPerPage);
    };

    const handleSectionChange = useCallback(
        async (lead: any, tab, partnerList) => {
            const widget = {
                type: 'leadCRMDetail',
                data: lead,
                config: config,
                crmType: platform,
                selectedSection: tab,
                platformData: platformData,
                platformInfo: platformInfo,
                agentList: agentList,
                partnersList: partnerList
            };
            return changeWidgets([widget]);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [changeWidgets, config, platform]
    );

    const findLead = async (lead, tab) => {
        setLoading(true);
        let resp = await handlePartner(tab, lead, page, perPage);
        if(resp){
            return handleSectionChange(lead, tab, resp)
        }
    }

    const onChangeAgent = async (newAgent, section) => {
        setLoading(true);
        
        let resp = await onHandleChangeAgent(newAgent, section, lead, agent);
        resp ? getLeadByUuid(lead['uuid'], section) : setLoading(false);
    };

    const onChangeStatus = async (section, key, e) => {
        setLoading(true);
        let value = e.target.value;

        const resp = await onHandleChangeStatus(section, key, value, lead, agent);
        resp ? getLeadByUuid(lead['uuid'], section) : setLoading(false);
    }

    const onUpdateCompanyContact = async (row) => {
        setLoading(true);

        const resp = await onHandleUpdateCompanyContact(row, lead, agent);
        resp ? getLeadByUuid(lead['uuid'], "company") : setLoading(false);
    }

    const onUpdateCommissions = async (payload, section) => {
        setLoading(true);
        
        let resp = await onHandleCommissionUpdate(payload, agent);
        resp ? getLeadByUuid(lead['uuid'], section) : setLoading(false);
    };

    const handleGetInfo = (section, leadData, crmType, aList, partnerList) => {
        const i = [];
        i.push(
            { key: 'origin_platform', label: 'Fuente del lead', section: 'all', type: 'select', catalog: 'origin_platform'},
            { key: 'tracking_status', label: 'Seguimiento', section: 'contact', type: 'select', catalog: 'trackingStatus'},
            { key: 'status', label: 'Estatus del lead', section: 'contact', type: 'select', catalog: 'contactStatus'},
            
            { key: 'low_funnel', label: 'Etapa del flujo', section: 'company', type: 'select', catalog: 'crmLowFunnel'},
            { key: 'funnel', label: 'Estatus Onboarding', section: 'company', type: 'disabled', catalog: 'ctFunnel'},
            { key: 'agent', label: 'Agente asignado', section: 'all', agents: agentList}
        );
        
        if(localStorage.config && JSON.parse(localStorage.config)['commissions'] && section === "company"){
            i.push({ key: 'commissions', label: 'Comisiones', section: 'company', type: "button"})
        }
        setInfo(i);

        setAgentList(aList);
        if(lead['agent'] && aList){
            let checkAgent = aList.filter((a) => a['uuid'] === lead['agent']['uuid'])
            setCheck(checkAgent.length > 0 ? true : false)
        }

        setActiveSection(section);
        setPlatform(crmType);

        if(partnerList && partnerList['content'].length > 1 && lead["ppal_contact"]){
            partnerList['content'].unshift(partnerList['content'].splice(partnerList['content'].findIndex(e => e.uuid === lead["ppal_contact"]["uuid"]), 1)[0])
        }
       
        return partnerList ? saveData(partnerList) && setLoading(false) : getPartner(section, leadData, page, perPage, crmType);
    };

    const calculateColumns = useMemo(() => {
        const columns = []
        activeSection === 'company' ?
        columns.push(
            {   cell: (row) => {
                    return lead["ppal_contact"] && lead["ppal_contact"]["uuid"] === row["uuid"] ?
                    <Tooltip title={'Contacto principal'}>
                        <IconButton sx={{px: '0 !important', mr: 1}} ><HowToRegIcon fontSize='small' color='success'/></IconButton>
                    </Tooltip>
                        : 
                    <Tooltip title={'Asignar como principal'}>
                        <IconButton sx={{px: '0 !important', mr: 1}} onClick={onUpdateCompanyContact.bind(this, row)} ><HowToRegIcon fontSize='small' color='disabled' cursor={'pointer'}/></IconButton>
                    </Tooltip>
                        
                }, wrap: true, sortable: true, width: "5%"
            },
            {   cell: (row) => {
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    return <a href='#' onClick={findLead.bind(this, row, 'contact')} title='Ver detalle'>{row.general.gname + ' ' + row.general.lname}</a>
                },
                name: 'Nombre', wrap: true, sortable: true
            },
            { selector: (row) => row.general.email, name: 'Correo', wrap: true, sortable: true },
            { selector: (row) => row.general['phone'] && row.general.phone.phone_code + ' ' + row.general.phone.phone, name: 'Teléfono', wrap: true, sortable: true, width: '22%' },
            { selector: (row) => moment(new Date(row.cdate)).tz('America/Mexico_City').format('LL'), name: 'Fecha de creación', wrap: true, sortable: true, width: '28%' },
        ) :
        columns.push(
            {   cell: (row) => {
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    return <a href='#' onClick={findLead.bind(this, row, 'company')} title='Ver detalle'>{row.general.company_name || 'Sin nombre'}</a>
                },
                name: 'Nombre de la Empresa', wrap: true, sortable: true, width: '35%'
            },
            { selector: (row) => row.general.onboarding_email, name: 'Correo', wrap: true, sortable: true, width: '30%' },
            { selector: (row) => platformData && platformData['crmLowFunnel'].map((item) => row.low_funnel === item.key ? item.label : null), name: 'Estatus', wrap: true, sortable: true },
            { selector: (row) => moment(new Date(row.udate)).tz('America/Mexico_City').format('L'), name: 'Última actividad', wrap: true, sortable: true },
        )
        return columns
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeSection, saveData, platformData])

    return {
        data,
        columns: calculateColumns,
        agentList,
        info,
        loading,
        page,
        perPage,
        totalRows,
        check,
        handlePageChange,
        handlePerRowsChange,
        onChangeStatus,
        onChangeAgent,
        handleGetInfo,
        onUpdateCommissions
    };
};
